/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */

import React from 'react'

import { TextField, MaskedTextField, TextFieldProps } from '@masfront/common-b2c'

// @TODO find a better name as it will work also for CC
export default function IbanInput(props: TextFieldProps) {
  // @TODO sync with store
  return (
    <TextField
      autoComplete="off"
      label="Introduce la cuenta bancaria o IBAN"
      id="iban"
      {...props}
      placeholder="ES11    1111    1111    1111    1111    1111"
      inputProps={{
        delimiter: '    ',
        blocks: [4, 4, 4, 4, 4, 4],
        style: { textTransform: 'uppercase', width: '364px' },
      }}
      InputProps={{
        inputComponent: MaskedTextField,
      }}
      variant="outlined"
    />
  )
}
